module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Light.ttf?4714ce217e468b3e231e986dcb37b10f";